const { Component } = Shopware;
const { Criteria } = Shopware.Data;

Component.override('sw-dashboard-index', {
    inject: [
        'premsPremiumItemApiService',
    ],

    mixins: [
        Shopware.Mixin.getByName('notification')
    ],

    data() {
        return {
            myPluginModalShown: false,
        };
    },

    mounted() {
        this.checkPremiumItemIapStatus();
    },

    methods: {
        premsPremiumItemIapCheckedToday() {
            const storageKey = 'prems-premium-item-iap-status-checked';

            const lastUpdate = Number.parseInt(localStorage.getItem(storageKey), 10);
            const oneDay = 24 * 60 * 60 * 1000;

            if (Number.isNaN(lastUpdate) || lastUpdate < Date.now() - oneDay) {
                localStorage.setItem(storageKey, Date.now().toString());
                return false;
            }
            return true;
        },

        checkPremiumItemIapStatus() {
            if (this.premsPremiumItemIapCheckedToday()) {
                return;
            }

            if (Shopware.InAppPurchase.isActive('PremsPremiumItem', 'premsPremiumItemAdvanced')) {
                return;
            }

            this.premsPremiumItemApiService.getMaxPremiumItemLimitReached().then((response) => {
                const data = response.data;
                if (data.premiumItemLimitReached) {
                    console.log("limit reached");
                    this.showPremiumItemIapWarningNotification(data.premiumItemLimitReached);
                }
            });
        },

        showPremiumItemIapWarningNotification() {
            const root = Shopware.Application.getApplicationRoot();

            if (!root) {
                throw new Error('Could not find applicationRoot');
            }
            console.log("show warning");
            const notification = {
                title: root.$tc('prems-premium-item.iap.warning-notification.title'),
                message: root.$tc('prems-premium-item.iap.warning-notification.free-premium-item-limit-reached'),
                variant: 'warning',
                actions: [
                    {
                        label: root.$tc('prems-premium-item.iap.warning-notification.fix-it'),
                        route: { name: 'prems.premium.item.index' },
                    },
                    {
                        label: root.$tc('prems-premium-item.iap.warning-notification.cancel'),
                    },
                ],
                autoClose: false,
            };

            this.createNotification(
                notification
            );
        }
    }
});